import React from "react";
import "./TableButton.css";

const TableButton = ({
  children,
  onClick,
  variant = "primary",
  disabled = false,
  className = "",
  ...rest
}) => {
  const base = "wg-table-btn";

  const classes = [
    base,
    `${base}--${variant}`,
    disabled && `${base}--disabled`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type="button"
      className={classes}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
};

export default TableButton;
